"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rc_layout_1 = require("@hangar31/rc-layout");
const react_1 = require("react");
function useBreakpoints() {
    const [breakpoint, setBreakpoint] = react_1.useState('xl');
    const updateMedia = () => {
        const bp = Object.keys(rc_layout_1.breakpoints).find(
        // @ts-ignore
        (size) => window.innerWidth < rc_layout_1.breakpoints[size]) || 'xl';
        setBreakpoint(bp);
    };
    react_1.useEffect(() => {
        updateMedia();
        window.addEventListener('resize', updateMedia);
        return () => window.removeEventListener('resize', updateMedia);
    });
    return breakpoint;
}
exports.default = useBreakpoints;
